import { laboratoryClient } from '../utils/laboratoryClient';
import { EXPERIMENTATION_SET_ELIGIBILITY } from './constants/ActionTypes';
import { PENDING, SUCCEEDED } from './constants/RequestStatus';
import { EXPERIMENTS } from './constants/RequestedDataTypes';
import { createRequestActions, createRequestTypes } from './helpers/RequestActions';
export const FetchExperimentsRequestTypes = createRequestTypes(EXPERIMENTS);
export const FetchExperimentsActions = createRequestActions(FetchExperimentsRequestTypes);
export const fetchExperiments = () => dispatch => {
  dispatch({
    type: FetchExperimentsRequestTypes.REQUEST,
    meta: {
      requestStatuses: {
        [FetchExperimentsRequestTypes.REQUEST]: PENDING
      }
    }
  });
  laboratoryClient.resolve(treatments => {
    return dispatch({
      type: FetchExperimentsRequestTypes.RECEIVE,
      payload: treatments,
      meta: {
        requestStatuses: {
          [FetchExperimentsRequestTypes.REQUEST]: SUCCEEDED
        }
      }
    });
  });
};
export const setExperimentEligibility = eligibleTreatment => {
  return {
    type: EXPERIMENTATION_SET_ELIGIBILITY,
    payload: eligibleTreatment
  };
};